import {TableDefinition} from "../table/table-definition";
import {TableModel} from "../table/table-model";
import {ContentModel} from "./content-model";
import {ViewDefinition} from "../view/view-definition";
import {ViewModel} from "../view/view-model";
import {FormDisplayType} from "../type/form-display-type.enum";
import {GridComponent} from "@syncfusion/ej2-angular-grids/src/grid/grid.component";

export class ListContentModel extends ContentModel {
  private _ngData: any = {
    listGrid: null
  };

  constructor(viewDefinitionOrModel: ViewDefinition | ViewModel, tableDefinitionOrModel: TableDefinition | TableModel, data?: any) {
    super(viewDefinitionOrModel, tableDefinitionOrModel, data);
    this.viewModel.setFormDisplayType(FormDisplayType.GRID);
  }

  setListGrid(listGrid: GridComponent) {
    this._ngData.listGrid = listGrid;
  }

  getListGrid() {
    return this._ngData.listGrid;
  }

  update(data: any, retainFieldValues?: boolean) {
    // Nothing done currently.
  }

}
